import { render } from "./Home.vue?vue&type=template&id=85b216c8&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-85b216c8"

export default script